export class Documents {
    constructor (){
        this.IsSecondaryOtherDocument = false;
    }
    public DocumentName: string;
    public DocumentPath: string;
    public DocumentId: number;
    public CustomerId: number;
    public DocumentStatus: number;
    public Status: boolean;
    public DocumentType: number;
    public DocumentFile: File;
    public clickPerformed: boolean;
    public isSizeExceeded: boolean;
    public isInValidFile: boolean;
    public hasNoFile: boolean;
    public IsOtherDocument: boolean;
    public DocumentTypeName: string;
    public Reason: string;
    public IsSecondaryOtherDocument: boolean;
    public IsJointApplicantDocument: boolean;
    public CommunicationDocumentType: number;
    public CommunicationDocumentTypeName: string;
    public IsAgentApproved: boolean;
}